

import React from 'react';
import {useTranslation} from "react-i18next";
import Helmet from "react-helmet";
import {SidebarData} from "../components/menu/data";
import {Link} from "react-router-dom";
import {BiCog, BiInfoCircle} from "react-icons/bi";
import {Stack} from "react-bootstrap";

function SiteMapPage(props) {

    const { t, i18n } = useTranslation()

    return (<div className={'vh-100 pt-5'}>

        <Helmet>
            <title>Yaroslav Lukyanchuk</title>
            <meta name="description" content="Yaroslav Lukyanchuk" />
        </Helmet>

        <div className="container text-dark text-start pt-5 mt-5">

            <h1>Site Map</h1>

            <div className="d-flex flex-wrap">

                <div id={'menu'}>
                    <h5 className={'mt-5'}>Menu</h5>
                    <div className="d-flex flex-wrap">
                        {SidebarData.map((item, index) => {
                            return (
                                <div key={index} className={`col-md-3 col-4 p-2`}>
                                    {
                                        <Link to={item.path} className={'nav-link'}>
                                            {item.icon}
                                            <span>{t('nav.' + item.title.toLowerCase())}</span>
                                        </Link>
                                    }
                                </div>
                            );
                        })}
                    </div>
                </div>

                <div id={'info'} className={'col-md-3 col-6 mt-5'}>

                    {/*<h5 className={'mt-5'}>  Information</h5>*/}
                    {/*<Stack direction="horizontal" gap={3}>*/}
                    {/*    <div className="p-2">Item 1</div>*/}
                    {/*    <div className="vr" />*/}
                    {/*    <div className="p-2">Item 2</div>*/}
                    {/*</Stack>*/}
                    <div className="d-flex justify-content-start align-items-center text-secondary">
                        <BiInfoCircle size={22} /> <h6 className={'p-2 pt-3'}>Information</h6>
                    </div>

                    <div className="d-flex h-auto p-2 pt-0">
                        <div className="vr" />
                        <div className={'links'}>
                            <Link to={'/info'} className={'nav-link p-3 pt-1 pb-0'}>Q&A</Link>

                            <Link to={'/info'} className={'nav-link p-3 pt-1 pb-0'}>Privacy policy</Link>

                            <Link to={'/info'} className={'nav-link p-3 pt-1 pb-0'}>Term of use</Link>

                            <Link to={'/info'} className={'nav-link p-3 pt-1'}>Payments</Link>
                        </div>
                    </div>

                    {/*<div className="border-start p-4">*/}
                    {/*    <Link to={'/info'} className={'nav-link'}>Q&A</Link>*/}

                    {/*    <Link to={'/info'} className={'nav-link'}>Privacy policy</Link>*/}

                    {/*    <Link to={'/info'} className={'nav-link'}>Term of use</Link>*/}

                    {/*    <Link to={'/info'} className={'nav-link'}>Payments</Link>*/}

                    {/*</div>*/}

                </div>

                <div id={'services'} className={'col-md-3'}>
                    <h5 className={'mt-5'}> <BiCog/> Services</h5>

                    <Link to={'/s/web-deb'} className={'nav-link  border-start p-2'}>Web Develop</Link>

                    <Link to={'/s/mobile-dev'} className={'nav-link border-start p-2'}>Mobile Develop</Link>
                </div>

                <div id={'work'} className={'col-md-3'}>
                    <h5 className={'mt-5'}>Work</h5>

                    <Link to={'/project/tracking'} className={'nav-link'}>Project tracking</Link>

                    <Link to={'/work'} className={'nav-link'}>Work process</Link>

                    <Link to={'/cooperation'} className={'nav-link'}>Cooperation</Link>
                </div>

                <div id={'portfolio'} className={'col-md-3'}>
                    <h5 className={'mt-5'}>Portfolio</h5>

                    <Link to={'/'} className={'nav-link'}>Project Name</Link>

                </div>

            </div>

        </div>
    </div>);
}

export default SiteMapPage;
